import { CustomerPrivacyApi } from './classes/customer_privacy_api';
import { CustomerPrivacyApiDisabled } from './classes/customer_privacy_api_disabled';
import Features from '@core/tools/features';

const isInIframe = window.frameElement !== null;
const isCustomerPrivacyEnabled = Features.isEnabled('customer_privacy') && !isInIframe;

export default isCustomerPrivacyEnabled ? new CustomerPrivacyApi() : new CustomerPrivacyApiDisabled();
